"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigation = exports.navigationPixel = void 0;
var axios_1 = require("axios");
var commonProperties_1 = require("./lib/commonProperties");
var config_1 = require("./config");
var _1 = require(".");
var ENDPOINT = function (baseUrl) { return baseUrl + "/Navigation"; };
exports.navigationPixel = function (numResults, baseUrl, modelName, numResultsByEntity) {
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, InitialUrl = _a.InitialUrl, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, Provider = _a.Provider, SearchType = _a.SearchType, Integration = _a.Integration, Filter = _a.Filter;
    var entity = {
        PageType: "AMP_" + PageType,
        SearchType: SearchType,
        Provider: Provider,
        SearchFilter: Filter,
        Origin: Origin,
        Integration: Integration,
        Platform: Platform || _1.Device.Mobile,
        NumResults: numResults,
        NumResultsByEntity: encodeURIComponent(commonProperties_1.toJSONString(numResultsByEntity)),
        InitialUrl: encodeURIComponent(InitialUrl || ''),
        ModelName: encodeURIComponent(commonProperties_1.toJSONString(modelName)),
        SearchCity: encodeURIComponent(SearchCity),
        SearchWord: encodeURIComponent(SearchWord),
        UserToken: commonProperties_1.getUserTokenAMP(),
        ClientTimeStamp: commonProperties_1.getFormattedClientTimeStamp(),
        TimeZoneOffset: commonProperties_1.getTimezoneOffset()
    };
    return ENDPOINT(baseUrl) + "/Pixel?entity=" + JSON.stringify(entity);
};
exports.navigation = function (numResults, baseUrl, getCookie, setCookie, modelName, numResultsByEntity) {
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, InitialUrl = _a.InitialUrl, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, SearchType = _a.SearchType, Integration = _a.Integration, Filter = _a.Filter, VariantName = _a.VariantName;
    var params = {
        SearchCity: SearchCity,
        SearchFilter: Filter,
        SearchWord: SearchWord,
        NumResults: numResults,
        InitialUrl: InitialUrl,
        PageType: PageType,
        Platform: Platform,
        Origin: Origin,
        SearchType: SearchType,
        Integration: Integration,
        ModelName: modelName,
        NumResultsByEntity: numResultsByEntity,
        VariantName: VariantName
    };
    axios_1.default.post(ENDPOINT(baseUrl), __assign(__assign({}, params), commonProperties_1.default(getCookie, setCookie)));
};
//# sourceMappingURL=navigation.js.map